import React from 'react';

// function Header({props}){


//     return(
//         <Fragment>
//     <h1>{titulo}</h1>
//     </Fragment>
//     )
// }

const Header  = ({titulo,cantidad}) => (  
    
        <h1>{titulo}</h1>
        
    );
   

export default Header;